import React, { useState, useEffect, useRef } from "react";

interface OTPBoxProps {
  onOTPComplete: (otp: string) => void;
}

const OTPBox: React.FC<OTPBoxProps> = ({ onOTPComplete }) => {
  const [otp, setOTP] = useState("");
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);

  useEffect(() => {
    if (inputRefs.current.length === 5) {
      inputRefs.current[0]?.focus();
    }
  }, []);

  const handleOTPChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const newOTP = otp.split("");
    newOTP[index] = e.target.value;
    const newOTPString = newOTP.join("");
    setOTP(newOTPString);

    if (e.target.value) {
      if (index === 4) {
        onOTPComplete(newOTPString);
      } else {
        inputRefs.current[index + 1]?.focus();
      }
    } else {
      if (index === 0) {
        inputRefs.current[0]?.focus();
      } else {
        inputRefs.current[index - 1]?.focus();
      }
    }
  };

  const handleOTPPaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    const pastedOTP = e.clipboardData.getData("text/plain").slice(0, 5);
    setOTP(pastedOTP);
    onOTPComplete(pastedOTP);
  };

  return (
    <div className="flex justify-start mt-4">
      {Array.from({ length: 5 }, (_, index) => (
        <input
          key={index}
          type="text"
          maxLength={1}
          value={otp[index]?.toUpperCase() || ""}
          onChange={(e) => handleOTPChange(e, index)}
          onPaste={handleOTPPaste}
          ref={(el) => (inputRefs.current[index] = el)}
          className={`w-12 h-12 mx-2 text-center text-2xl font-bold border-2 rounded-md focus:outline-none ${
            otp[index] ? "border-green-500" : "border-gray-300"
          }`}
        />
      ))}
    </div>
  );
};

export default OTPBox;
